import { SERVER_URL } from './../config/contants';
import { HEADERS } from './../config/contants';
import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import 'rxjs/add/operator/map';
import { LocalStorageProvider } from '../providers/local-storage';

@Injectable()
export class Cardapio {

  dados: any = [];
  pagina: number = 1;
  hasmore: boolean = false;
  firstloading: boolean = true;
  contentHeader: Headers = new Headers(HEADERS);

  constructor(
    public http: Http,
    public storage: LocalStorageProvider
  ) {
  }

  refresh() {
    this.pagina = 1;
    this.hasmore = false;
    this.dados = [];
  }

  setPage(page) {
    this.pagina = page;
  }

  checkHasmore() {
    return this.hasmore;
  }

  checkFirstloading() {
    return this.firstloading;
  }

  cardapioOpcoes() {
    return new Promise((resolve, reject) => {
      this.http.post(SERVER_URL + 'cardapio/categorias', null, { headers: this.contentHeader })
        .map(res => res.json())
        .subscribe(
        data => {
          this.firstloading = false;
          this.storage.storageSave('cardapio_opcoes', data);
          resolve(data)
        },
        err => {
          reject(err)
        }
        );
    });
  }

  cardapio(id) {
    return new Promise((resolve, reject) => {
      this.http.post(SERVER_URL + 'cardapio/produtos', JSON.stringify({ id: id, pagina: this.pagina }), { headers: this.contentHeader })
        .map(res => res.json())
        .subscribe(
        data => {

          this.hasmore = data.hasmore;

          for (var item of data.produtos) {
            this.dados.push(item);
          }

          if (this.pagina == 1) {
            this.storage.storageSave('cardapio_produtos_' + id, this.dados);
          }

          if (this.hasmore) {
            this.setPage(this.pagina + 1);
          }

          resolve(this.dados);
        },
        err => {
          reject(err)
        }
        );
    });
  }

  ofertas() {
    return new Promise((resolve, reject) => {
      this.http.post(SERVER_URL + 'cardapio/ofertas', JSON.stringify({ pagina: this.pagina }), { headers: this.contentHeader })
        .map(res => res.json())
        .subscribe(
        data => {
          this.hasmore = data.hasmore;

          if (this.hasmore) {
            this.setPage(this.pagina + 1);
          }

          for (var item of data.produtos) {
            this.dados.push(item);
          }

          resolve(this.dados);
        },
        err => {
          reject(err)
        }
        );
    });
  }

}



// WEBPACK FOOTER //
// ./src/providers/cardapio.ts